
import { Link } from "react-router-dom";
import { Zap } from "lucide-react";
import { motion } from "framer-motion";
import { useSiteSettings } from "@/hooks/useSiteSettings";
import { Skeleton } from "../ui/skeleton";

// Subtle animated logo for header
const Logo = () => {
  const { data: settings, isLoading } = useSiteSettings();

  if (isLoading) {
    return (
        <div className="flex items-center space-x-2">
             <Skeleton className="h-8 w-8 rounded-lg" />
             <Skeleton className="h-6 w-20 rounded" />
        </div>
    );
  }

  const showIcon = settings?.showLogoIcon !== false;
  const showText = settings?.showLogoText !== false;
  const logoText = settings?.logoText || 'VRAM';
  const logoUrl = settings?.logoUrl;
  const logoFontFamily = settings?.logoFontFamily || 'Poppins';
  const logoFontWeight = settings?.logoFontWeight || 600;

  const fontClass = {
    'Poppins': 'font-poppins',
    'Playfair Display': 'font-playfair',
    'Montserrat': 'font-montserrat',
    'Inter': 'font-sans'
  }[logoFontFamily] || 'font-sans';
  
  return (
    <motion.div
      whileHover={{ scale: 1.06, rotate: logoUrl ? 0 : 2 }}
      whileTap={{ scale: 0.97, rotate: logoUrl ? 0 : -3 }}
      transition={{ type: "spring", stiffness: 200, damping: 12 }}
      className="flex items-center"
    >
      <Link to="/" className="flex items-center space-x-2">
        {logoUrl ? (
          <img src={logoUrl} alt={logoText} className="h-8 w-auto max-h-8" />
        ) : (
          showIcon && (
            <motion.div
              animate={{ rotate: [0, 12, -8, 0] }}
              transition={{ repeat: Infinity, duration: 4, ease: "easeInOut" }}
              className="h-8 w-8 bg-gradient-to-br from-primary to-secondary rounded-lg flex items-center justify-center shadow"
            >
              <Zap className="h-5 w-5 text-primary-foreground" />
            </motion.div>
          )
        )}
        {showText && <span 
          className={`text-xl text-foreground tracking-wider ${fontClass}`}
          style={{ fontWeight: logoFontWeight }}
          >
            {logoText}
        </span>}
      </Link>
    </motion.div>
  );
};

export default Logo;

